module.exports = __webpack_public_path__ + "static/media/angle-double-up-solid.f59f91f1.svg";